import React from 'react'
import { Note as NT } from '@constants'

import FrameToolbar from '../Frame/Toolbar'
import {
  Alignment,
  Bold,
  Italic,
  Underline,
  Strike,
  Image,
  Font,
  List
} from './Tools'

const Toolbar = ({ tools, activate, close, history }) => {
  return (
    <FrameToolbar
      close={close}
      history={history}
      component={{ title: 'Note', type: 'note', icon: 'text' }}
      tools={[
        [
          <Bold
            active={tools.includes(NT.TOOLS.BOLD)}
            onClick={() => activate(NT.TOOLS.BOLD)}
            dark
            key='bold'
          />,
          <Italic
            active={tools.includes(NT.TOOLS.ITALIC)}
            onClick={() => activate(NT.TOOLS.ITALIC)}
            dark
            key='italic'
          />,
          <Underline
            active={tools.includes(NT.TOOLS.UNDERLINE)}
            onClick={() => activate(NT.TOOLS.UNDERLINE)}
            dark
            key='underline'
          />,
          <Strike
            active={tools.includes(NT.TOOLS.STRIKE)}
            onClick={() => activate(NT.TOOLS.STRIKE)}
            dark
            key='strike'
          />,
          <Alignment
            active={[
              NT.TOOLS.ALIGN.LEFT,
              NT.TOOLS.ALIGN.RIGHT,
              NT.TOOLS.ALIGN.CENTER,
              NT.TOOLS.ALIGN.JUSTIFY
            ].find((v) => tools.includes(v))}
            onClick={(alignment) => activate(NT.TOOLS.ALIGN, alignment)}
            dark
            key='alignment'
          />,
          <Font
            active={[
              NT.TOOLS.HEADER.H1,
              NT.TOOLS.HEADER.H3,
              NT.TOOLS.HEADER.NORMAL
            ].find((v) => tools.includes(v))}
            onClick={(header) => activate(NT.TOOLS.HEADER, header)}
            dark
            key='font'
          />,
          <List
            active={[NT.TOOLS.LIST.BULLET, NT.TOOLS.LIST.NUMERIC].find((v) =>
              tools.includes(v)
            )}
            onClick={(list, value) =>
              activate(NT.TOOLS.LIST, tools.includes(list) ? false : value)
            }
            dark
            key='list'
          />,
          <Image dark onClick={() => activate(NT.TOOLS.IMAGE)} key='image' />
        ]
      ]}
    />
  )
}

export default Toolbar
